import controller from './new-campus-modal-controller';
import template from './new-campus-modal.html';

const NewCampusModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default NewCampusModalComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/new-campus-modal/new-campus-modal-component.js